<div class="row">
  <h3 class="text-start fs-4 mb-3">{{ 'onboardingArtistProduct.heading' | transloco }}</h3>
  <div class="fs-6 mb-2">
    {{ 'onboardingArtistProduct.intro' | transloco }}
  </div>
  <ul class="dsList ms-4 me-2">
    <li>{{ 'onboardingArtistProduct.step1' | transloco }}</li>
    <li>{{ 'onboardingArtistProduct.step2' | transloco }}</li>
    <li>{{ 'onboardingArtistProduct.step3' | transloco }}</li>
    <li>{{ 'onboardingArtistProduct.step4' | transloco }}</li>
    <li>{{ 'onboardingArtistProduct.step5' | transloco }}</li>
  </ul>
  <form class="form-group mt-4 mb-3" #form="ngForm">
    <!-- Product Image Upload -->
    @if (!selectedItem.ProductImgUrl) {
      <div class="mt-3">
        <label class="form-label">{{ 'onboardingArtistProduct.productImage' | transloco }}</label>
        <p-fileUpload name="productImageFile" accept="image/*" (onSelect)="onFileSelected($event.files)"
          [chooseLabel]="'onboardingArtistProduct.selectImage' | transloco" [auto]="true" [previewWidth]="70" styleClass="upload_image" [multiple]="false"
          mode="advanced">
          <ng-template pTemplate="toolbar">
            <div class="mt-2">{{ 'onboardingArtistProduct.dragAndDropFile' | transloco }}</div>
          </ng-template>
        </p-fileUpload>
      </div>
    }
    <!-- Display Selected Image -->
    @if (selectedItem.ProductImgUrl) {
      <div class="mt-4 mb-3">
        <div class="position-relative d-inline-block justify-content-center">
          <img [src]="selectedItem.ProductImgUrl" class="img rounded" style="object-fit: cover; height: 200px; width: 200px;" [alt]="'onboardingArtistProduct.productImage' | transloco" />
          <div class="position-absolute top-0 end-0 m-2">
            <button type="button" class="btn btn-sm btn-danger" (click)="removeImg($event)">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    }
    <!-- Product Name Input -->
    <div class="form-group flex-grow-1">
      <label class="form-label">
        <span class="text-danger">*</span> {{ 'onboardingArtistProduct.productName' | transloco }}
      </label>
      <input type="text" id="productName" name="productName" [(ngModel)]="selectedItem.Name" class="form-control w-100"
        [placeholder]="'onboardingArtistProduct.artworkName' | transloco" required />
      </div>

    </form>
    <div class="dsButtonDiv justify-content-between d-flex  mt-3 mb-2">
      <button class="btn btn-outline-secondary"  routerLink="/">{{ 'onboardingArtistProduct.skip' | transloco }}</button>
      <div class="align-items-center">
        <button type="button" pButton [label]="'onboardingArtistProduct.viewYourArtworks' | transloco"  class="btn btn-outline-secondary"  [routerLink]="['/artists', 'artworks']"></button>
        <button type="button" pButton [label]="'onboardingArtistProduct.saveAndExit' | transloco" [disabled]="!selectedItem.Name" (click)="saveProduct($event)" class="btn btn-outline-secondary ms-2">
        </button>
        <button type="button" pButton [label]="'onboardingArtistProduct.exit' | transloco"  (click)="Exit($event)" class="btn btn-outline-secondary ms-2">
        </button>
      </div>

    </div>
  </div>
  <!-- Image Cropper Dialog -->
  @if (showCropperDialog) {
    <app-image-cropper [showCropperDialog]="showCropperDialog" [isAdditionalImage]="isAdditionalImage"
      [image]="currentSelectedImageToCrop" (onImageCropped)="onImageCropped($event)"
    (onImageCropperClose)="onImageCropperClose($event)"></app-image-cropper>
  }